import { Model } from "@vuex-orm/core";
import Resolution from "./Resolution";
import Tag from "./Tag";
import ResolutionCatalogTag from "./ResolutionCatalogTag";

export default class ResolutionCatalog extends Model {
  static get entity() {
    return "resolutions_catalogs";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      resolutions: this.hasMany(Resolution, "resolution_catalog_id"),

      tags: this.belongsToMany(Tag, ResolutionCatalogTag, "resolution_catalog_id", "tag_id"),
    };
  }
}
